{
  "name": "camelot",
  "version": "6.2.0",
  "type": "module",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start-local": "ng serve --configuration local",
    "pre-build-skin": "node ./partners/apply-skin.js",
    "build-website": "ng build",
    "watch-website": "ng build --watch --configuration development",
    "checkfiles": "yarn install --check-files",
    "clean:dist": "rm -rf projects/*/dist projects/*/*/dist",
    "build": "yarn run clean:dist && nx run-many --target=build --all",
    "watch:lib": "node scripts/build-affected.mjs --initial && nx watch --all -- node scripts/build-affected.mjs",
    "clean": "rm -rf **/*/dist **/*/node_modules node_modules .angular yarn.lock",
    "publish": "nx release publish",
    "version": "nx release version",
    "lint": "ng lint --fix",
    "prettier": "npx prettier --write .",
    "e2e": "playwright test",
    "e2e:ui": "playwright test --ui",
    "e2e:headed": "playwright test --headed",
    "e2e:visual": "node e2e/visual-skins.mjs",
    "e2e:visual:update": "node e2e/visual-skins.mjs --update",
    "e2e:showcase-coverage": "node e2e/showcase-coverage.mjs",
    "unit": "ng test unit --watch=false --browsers=ChromeHeadless"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.0",
    "@angular/cdk": "^22.1.1",
    "@angular/common": "^22.1.0",
    "@angular/compiler": "^22.1.0",
    "@angular/core": "^22.1.0",
    "@angular/forms": "^22.1.0",
    "@angular/material": "^22.1.1",
    "@angular/platform-browser": "^22.1.0",
    "@angular/platform-browser-dynamic": "^22.1.0",
    "@angular/router": "^22.1.0",
    "@angular/service-worker": "^22.1.0",
    "fs-extra": "^11.3.0",
    "inquirer": "^12.1.0",
    "rxjs": "~7.8.0",
    "simple-git": "^3.27.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^22.1.3",
    "@angular/cli": "~22.1.3",
    "@angular/compiler-cli": "^22.1.0",
    "@axe-core/playwright": "^4.12.1",
    "@nx/js": "22.7.8",
    "@playwright/test": "^1.62.1",
    "@types/jasmine": "~4.3.0",
    "angular-eslint": "18.4.3",
    "eslint": "^9.15.0",
    "jasmine-core": "~4.5.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "ng-packagr": "^22.1.1",
    "nx": "^22.7.8",
    "sass": "^1.63.4",
    "typescript": "6.0.3",
    "typescript-eslint": "8.16.0"
  },
  "workspaces": [
    "projects/*",
    "projects/form/*",
    "projects/config/*",
    "projects/files/*",
    "projects/features/*",
    "projects/testing/*"
  ],
  "main": "index.js",
  "repository": "https://merlin-software@dev.azure.com/merlin-software/Camelot/_git/Camelot",
  "author": "Geoffrey L <g.lambert@merlinsoftware.be>",
  "license": "MIT",
  "sideEffects": false
}
